<template >
    <section>
        <div class="row">
            <div class="col-12">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mb-2">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ student.user ? student.user.name : '' }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Data Kepesertaan Siswa BTA
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tahun Ajaran</label>
                                </div>
                                <!--<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-bind:value="student.term.name" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm" />
                                </div>-->
				                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.student.termID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled required>
                                        <option disabled value="">Pilih Tahun Ajaran...</option>
                                        <option v-for="term in terms" v-bind:value="term.id" v-bind:key="term.id">{{ term.name }}</option>
                                    </select>
				                    <!-- <input v-else class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="student.term.name" /> -->
                                </div>
                            </div>
                            
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">No. Kepesertaan</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.student.identity" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Tanggal Daftar</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.student.registeredAt" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required></datepicker>
                                    </div>
                                    <input v-if="student.registeredAt" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(student.registeredAt, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-if="profile && profile.isAdmin" v-model="form.student.branchID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled required>
                                        <option disabled value="">Pilih Cabang...</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                    </select>
                                    <input v-else class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="student.branch ? student.branch.name : ''" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Program</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="branchProgramID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Program...</option>
                                        <option v-for="branchProgram in branchPrograms" v-bind:value="branchProgram.id" v-bind:key="branchProgram.id">{{ branchProgram.grade.name }} - {{ branchProgram.programType.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Semester 1</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.patternID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Pola...</option>
                                        <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Semester 1</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.branchClassID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Kelas...</option>
                                        <option v-for="branchClass in branchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Semester 2</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.secondPatternID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Pola...</option>
                                        <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Semester 2</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.secondBranchClassID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Kelas...</option>
                                        <option v-for="branchClass in secondBranchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Super Intensif UTBK</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.thirdPatternID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Pola...</option>
                                        <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Super Intensif UTBK</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.thirdBranchClassID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Kelas...</option>
                                        <option v-for="branchClass in thirdBranchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Intensif Mandiri</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.fourthPatternID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Pola...</option>
                                        <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Intensif Mandiri</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.fourthBranchClassID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Kelas...</option>
                                        <option v-for="branchClass in fourthBranchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Sesi Intensif</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.intensiveScheduleID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Sesi Intensif...</option>
                                        <option v-for="intensive in intensives" v-bind:value="intensive.id" v-bind:key="intensive.id">{{ intensive.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <!--<div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Intensif</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.verified.intensiveClassID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled>
                                        <option value="">Pilih Kelas Intensif...</option>
                                        <option v-for="intensiveClass in intensiveClasses" v-bind:value="intensiveClass.id" v-bind:key="intensiveClass.id">{{ intensiveClass.name }}</option>
                                    </select>
                                </div>
                            </div>-->
			    
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Ruang Placement Test</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.verified.placement" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
			                <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Rencana Pola Hari</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.verified.paymentNote" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
			                <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Rencana Pembelajaran</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <div class="form-check form-check-inline py-1" v-for="learn in ['Online', 'Offline']">
                                            <div class="custom-control custom-radio">
                                                <input v-model="form.profile.pembelajaran" type="radio" class="custom-control-input" v-bind:value="learn" v-bind:id="'input-pembelajaran-' + learn" />
                                                <label class="custom-control-label h4" v-bind:for="'input-pembelajaran-' + learn">{{ learn }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <input class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="form.profile.pembelajaran" />
                                </div>
                            </div>

                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tahapan Pembayaran</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.verified.payment" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>

                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Informasi BTA dari</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile.ukuran_jaket" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pembayaran Tahap 1</label>
                                </div>
                                <!--<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile.diterima_jalur" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>-->
				            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.profile.diterima_jalur" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required></datepicker>
                                    </div>
                                    <input v-if="form.profile.diterima_jalur" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile.diterima_jalur, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pembayaran Tahap 2</label>
                                </div>
                                <!--<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile.diterima_univ" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>-->
				            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.profile.diterima_univ" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required></datepicker>
                                    </div>
                                    <input v-if="form.profile.diterima_univ" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile.diterima_univ, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <!--<div class="row mb-1 align-items-center" v-for="attribute in ['diterima_prodi']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pembayaran Tahap 3</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
				
                            </div>-->
			                <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pembayaran Tahap 3</label>
                                </div>
				                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.profile.diterima_prodi" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required></datepicker>
                                    </div>
                                    <input v-if="form.profile.diterima_prodi" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile.diterima_prodi, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="n in 3">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Sekolah/ Universitas Impian {{ n }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile['sekolah_impian_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-8 col-sm-12">
                <div class="d-flex flex-wrap justify-content-end align-items-center mb-3">
                    <button v-b-tooltip.hover title="Download file laporan nilai siswa" v-on:click="downloadReport" type="button" class="btn btn-sm btn-danger px-3 mr-2 mb-2">
                        Download Laporan Nilai
                    </button>
                    <router-link v-bind:to="{name: 'student/attend', params: {id: student.userID}}" class="btn btn-danger btn-sm px-4 mr-2 mb-2">
                        Laporan Kehadiran
                    </router-link>
                    <router-link v-bind:to="{name: 'student/score', params: {id: student.userID}}" class="btn btn-danger btn-sm px-4 mr-2 mb-2" v-if="roleElligibleView()">
                        Laporan Nilai Siswa
                    </router-link>
                    <button type="button" class="btn btn-danger btn-sm px-3 mr-2 mb-2" v-on:click="openResetPasswordModal" v-if="roleElligibleModified()" v-b-tooltip.hover title="Reset password siswa ini">
                        <i class="fa fa-key mr-1"></i> Reset Password
                    </button>
                    <button type="button" class="btn btn-outline-danger btn-sm px-4 mr-2 mb-2" v-on:click="modal.remove.student = true" v-if="roleElligibleModified()">
                        Hapus Siswa
                    </button>
                    <button v-b-tooltip.hover title="Download Kuitansi Formulir Siswa" v-on:click="downloadKuiform" type="button" class="btn btn-sm btn-danger px-3 mr-2 mb-2">
                        Download Kuitansi Formulir
                    </button>
                    <button v-b-tooltip.hover title="Download Kuitansi Bimbingan Siswa" v-on:click="downloadKuibim" type="button" class="btn btn-sm btn-danger px-3 mr-2 mb-2">
                        Download Kuitansi Bimbingan
                    </button>
                    <button v-b-tooltip.hover title="Download Formulir Siswa" v-on:click="downloadForm" type="button" class="btn btn-sm btn-danger px-3 mb-2">
                        Download Formulir Siswa
                    </button>
                </div>

                <div class="card shadow-sm mb-4 border-0" v-if="student.psychoScore">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Laporan Psikotes
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Golongan IQ</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="h4 mb-0 font-weight-medium">{{ student.psychoScore.categoryIQ }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="n in 3">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Rekomendasi {{ n }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="h4 mb-0 font-weight-medium">{{ student.psychoScore['recommendation' + n] }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-if="student.psychoScore.fileScore">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">File</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <button v-b-tooltip.hover title="Download file psikotes siswa" v-on:click="downloadFile" type="button" class="btn btn-sm btn-link font-weight-medium p-0">
                                    <file-icon v-bind:type="student.psychoScore.fileExtension" class="mr-1"></file-icon> Download
                                </button>
                                <button v-b-tooltip.hover title="Menghapus file psikotes siswa" v-on:click="modal.remove.file = true" type="button" class="btn btn-sm btn-link font-weight-medium float-right py-0">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		<form v-on:submit.prevent="save" disabled>
            <div class="card shadow-sm mb-4 border-0">
                <div class="card-header background-primary">
                    <div class="row justify-content-end">
                        <div class="col">
                            <span class="h4 font-weight-medium text-white mb-0">
                                Pengisian Kuitansi
                            </span>
                        </div>
                            <div class="col-auto" v-if="roleElligibleModified()">
                                <div class="edit-action">
                                    <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                        Edit
                                    </button>
                                </div>
                                <div class="input-action">
                                    <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                        Save
                                    </button>
                                    <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                    </div>
                </div>
                <div class="card-body">
                        <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_formulir']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['IUP_nomor']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Petugas Kuitansi</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['IUP_prodi']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Metode Pembayaran</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Tunai/Transfer Via Bank" />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['TS_nomor']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kode Transfer</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['TS_univ']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Untuk Pembayaran</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Biaya Bimbingan Lunas/Bertahap" />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['TS_prodi']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Jumlah</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="11.000.000" />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_nomor']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Terbilang</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Sebelas Juta Rupiah" />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_univ']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Cetak</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="15 AGUSTUS 2020" />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_prodi']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Rekening Pengirim</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm"  />
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center" v-for="attribute in ['Mandiri_3_nomor']">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nomor Referensi</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm"  />
                        </div>
                    </div>
        
                </div>
            </div>
            <div class="card shadow-sm mb-4 border-0" v-if="student.product">
                <div class="card-header background-primary">
                    <div class="row justify-content-end">
                        <div class="col">
                            <span class="h4 font-weight-medium text-white mb-0">
                                Produk
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <!--<img v-bind:src="student.product.imageUrl" class="w-100 img-fluid mb-3" />-->
                    <div class="row mb-1 align-items-center">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Nama</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <h4 class="font-weight-medium mb-0 py-1">{{ student.product.name }}</h4>
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Harga</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <h4 class="font-weight-medium mb-0 py-1">{{ student.product.price | currency }}</h4>
                        </div>
                    </div>
                    <div class="row mb-1 align-items-center">
                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Deskripsi</label>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                            <h4 class="font-weight-medium mb-0 py-1">{{ student.product.description }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 1 -->
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Profil Siswa <span class="badge badge-info d-inline-block" v-b-tooltip.hover title="Forum Credit">{{ student.remainingVouchers }}</span>
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12">
                                            <div v-bind:style="'background-image: url(' + imagePreview +')'" class="user-avatar rounded-circle">
                                                <div class="overlay rounded-circle text-center text-white" v-on:click="$refs.upload.click()">
                                                    <i class="fa fa-upload"></i>
                                                </div>
                                                <input ref="upload" type="file" class="form-control" v-on:change="preview" accept="image/*" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Username</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.student.username" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Lengkap</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.student.name" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Alamat Email</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.student.email" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Asal Sekolah</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <multiselect v-model="school" v-on:select="school => form.student.schoolID = school.id" v-bind:options="schools" v-bind:allow-empty="false" tag-placeholder="" select-label="" label="name" track-by="id" placeholder="Asal Sekolah" class="form-control form-control-sm wrapper-input font-weight-medium" required>
                                            </multiselect>
                                            <input v-bind:value="school ? school.name : ''" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Prodi Sekolah</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.student.gradeID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled required>
                                                <option value="">Pilih Kelas...</option>
                                                <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id" v-sortable>{{ grade.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Prodi BTA</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.student.btaGradeID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled required>
                                                <option value="">Pilih Kelas...</option>
                                                <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id">{{ grade.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="wrapper-input">
                                                <datepicker v-model="form.profile.tanggal_lahir" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}"  input-class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm"></datepicker>
                                            </div>
                                            <input v-if="student.additionals && student.additionals.tanggal_lahir" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(student.additionals.tanggal_lahir, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Jenis Kelamin</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="wrapper-input">
                                                <div class="form-check form-check-inline py-1" v-for="gender in ['Laki-laki', 'Perempuan']">
                                                    <div class="custom-control custom-radio">
                                                        <input v-model="form.profile.jenis_kelamin" type="radio" class="custom-control-input" v-bind:value="gender" v-bind:id="'input-jenis_kelamin-' + gender" />
                                                        <label class="custom-control-label h4" v-bind:for="'input-jenis_kelamin-' + gender">{{ gender }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <input class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="form.profile.jenis_kelamin" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['alamat_rumah', 'kode_pos', 'nomor_telp_rumah', 'nomor_hp_siswa']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 2 -->
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Orang Tua Siswa
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['nama_ayah', 'nomor_hp_ayah', 'email_ayah', 'pekerjaan_ayah', 'nama_ibu', 'nomor_hp_ibu', 'email_ibu', 'pekerjaan_ibu']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <!-- Section 3 -->
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan SBMPTN
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['SBMPTN_nomor']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <template v-for="n in 2">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Univ {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SBMPTN_univ_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SBMPTN_prodi_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                            </div>
                                        </div>
                                    </template>

                                    <template v-for="n in 2">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Nilai UTBK {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                                <h4 class="font-weight-medium mb-0">
                                                    {{ (student.additionals && student.additionals['nilai_UTBK_' + n]) ? student.additionals['nilai_UTBK_' + n] : '' }}
                                                </h4> 
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-5 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    File UTBK {{ n }}
                                                </label>
                                            </div>
                                            <div class="col-sm-7 col-12 px-1">
                                                <button v-on:click="downloadUTBK(n)" type="button" class="btn btn-sm btn-link font-weight-medium p-0" v-if="student.additionals && student.additionals['file_UTBK_' + n]">
                                                    <file-icon v-bind:type="fileExtension(student.additionals['file_UTBK_' + n])" class="mr-1"></file-icon> Download
                                                </button>
                                                <i class="fa fa-minus" v-else></i>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 4 -->
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan SNMPTN
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['SNMPTN_nomor']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <template v-for="n in 3">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Univ {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SNMPTN_univ_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SNMPTN_prodi_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </form>

                        <!-- Section 5 
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan PPKB
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_nomor', 'PPKB_univ', 'PPKB_prodi']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>-->

                        <!-- Section 6 
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan IUP UGM
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['IUP_nomor', 'IUP_prodi']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>-->

                        <!-- Section 10 -->
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Penerimaan Kuliah
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Universitas 1</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="multiselect-wrapper">
                                                <multiselect
                                                    id="multiselect-penerimaan-university-1"
                                                    v-model="selectedPenerimaanUniversity"
                                                    v-bind:options="universities"
                                                    tag-placeholder=""
                                                    select-label=""
                                                    label="name"
                                                    track-by="name"
                                                    placeholder="Universitas 1"
                                                    class="form-control form-control-sm toggle-multiselect"
                                                ></multiselect>
                                            </div>
                                            <input v-model="form.profile.Penerimaan_univ_1" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-if="form.profile.Penerimaan_univ_1">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi 1</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="multiselect-wrapper">
                                                <multiselect
                                                    v-model="selectedPenerimaanCourse"
                                                    v-on:select="(universityCourse) => (form.profile.Penerimaan_prodi_1 = universityCourse.name)"
                                                    v-on:remove="() => (form.profile.Penerimaan_prodi_1 = '')"
                                                    v-bind:options="penerimaanUniversityCourses"
                                                    tag-placeholder=""
                                                    select-label=""
                                                    label="name"
                                                    track-by="name"
                                                    placeholder="Prodi 1"
                                                    class="form-control form-control-sm toggle-multiselect"
                                                ></multiselect>
                                            </div>
                                            <input v-model="form.profile.Penerimaan_prodi_1" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Universitas 2</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="multiselect-wrapper">
                                                <multiselect
                                                    id="multiselect-penerimaan-university-2"
                                                    v-model="selectedPenerimaanUniversity2"
                                                    v-bind:options="universities"
                                                    tag-placeholder=""
                                                    select-label=""
                                                    label="name"
                                                    track-by="name"
                                                    placeholder="Universitas 2"
                                                    class="form-control form-control-sm toggle-multiselect"
                                                ></multiselect>
                                            </div>
                                            <input v-model="form.profile.Penerimaan_univ_2" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-if="form.profile.Penerimaan_univ_2">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi 2</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="multiselect-wrapper">
                                                <multiselect
                                                    v-model="selectedPenerimaanCourse2"
                                                    v-on:select="(universityCourse) => (form.profile.Penerimaan_prodi_2 = universityCourse.name)"
                                                    v-on:remove="() => (form.profile.Penerimaan_prodi_2 = '')"
                                                    v-bind:options="penerimaanUniversityCourses2"
                                                    tag-placeholder=""
                                                    select-label=""
                                                    label="name"
                                                    track-by="name"
                                                    placeholder="Prodi 2"
                                                    class="form-control form-control-sm toggle-multiselect"
                                                ></multiselect>
                                            </div>
                                            <input v-model="form.profile.Penerimaan_prodi_2" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Universitas 3</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile.Penerimaan_univ_3" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Ketik nama Universitas (jika tidak ada di pilihan)" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-show="form.profile.Penerimaan_univ_3">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi 3</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile.Penerimaan_prodi_3" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Ketik nama Prodi" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 7 
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan Talent Scouting
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['TS_nomor', 'TS_univ', 'TS_prodi']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>-->
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 8 -->
                        <form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan Ujian Mandiri
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <template v-for="n in 2">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nomor Ujian Mandiri {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['Mandiri_' + n + '_nomor']" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Universitas Ujian Mandiri {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['Mandiri_' + n + '_univ']" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm"  />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi Ujian Mandiri {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['Mandiri_' + n + '_prodi']" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm"  />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 9 -->
												<!--<form v-on:submit.prevent="save" disabled>
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan SIMAK UI
                                            </span>
                                        </div>
                                        <div class="col-auto" v-if="roleElligibleModified()">
                                            <div class="edit-action">
                                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                    Edit
                                                </button>
                                            </div>
                                            <div class="input-action">
                                                <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                    Save
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['SIMAK_nomor']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="n in 7">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['SIMAK_prodi_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>-->
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="modal.remove.student" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus siswa ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="removeStudent">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove.student = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modal.remove.file" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus file psikotes ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="removeFile">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove.file = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Modal Reset Password -->
        <b-modal v-model="modal.resetPassword" modal-class="border-0" header-class="background-primary text-white" v-bind:centered="true" v-bind:hide-footer="true" size="md" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h5 class="modal-title font-weight-bold text-white mb-0">
                    <i class="fa fa-key mr-2"></i> Reset Password Siswa
                </h5>
                <button type="button" class="close text-white" v-on:click="modal.resetPassword = false">&times;</button>
            </template>
            <div class="container py-2">
                <div class="card bg-light border-0 mb-3">
                    <div class="card-body p-3">
                        <div class="row small mb-1">
                            <div class="col-4 text-muted">No. Peserta</div>
                            <div class="col-8 font-weight-bold text-dark">{{ student.identity }}</div>
                        </div>
                        <div class="row small mb-1">
                            <div class="col-4 text-muted">Nama Siswa</div>
                            <div class="col-8 font-weight-bold text-dark">{{ student.user ? student.user.name : '-' }}</div>
                        </div>
                        <div class="row small mb-1">
                            <div class="col-4 text-muted">Username</div>
                            <div class="col-8 font-weight-bold text-danger">{{ student.user ? student.user.username : '-' }}</div>
                        </div>
                        <div class="row small" v-if="student.user && student.user.email">
                            <div class="col-4 text-muted">Email</div>
                            <div class="col-8 text-dark">{{ student.user.email }}</div>
                        </div>
                    </div>
                </div>

                <form v-on:submit.prevent="submitResetPassword">
                    <div class="form-group mb-2">
                        <label class="font-weight-medium small mb-1">Metode Pengaturan Password:</label>
                        <div class="d-flex">
                            <div class="custom-control custom-radio mr-3">
                                <input type="radio" id="view-method-default" v-model="resetPasswordData.mode" value="default" class="custom-control-input" v-on:change="onResetModeChange" />
                                <label class="custom-control-label small" for="view-method-default">Password Default (12345678)</label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input type="radio" id="view-method-manual" v-model="resetPasswordData.mode" value="manual" class="custom-control-input" v-on:change="onResetModeChange" />
                                <label class="custom-control-label small" for="view-method-manual">Input Password Manual</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mb-3">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <label class="font-weight-medium small mb-0 required">Password Baru</label>
                            <button type="button" class="btn btn-link btn-sm p-0 text-danger small" v-on:click="setDefaultPassword">
                                <i class="fa fa-undo mr-1"></i> Set Default (12345678)
                            </button>
                        </div>
                        <div class="input-group input-group-sm">
                            <input v-model="resetPasswordData.password"
                                   v-bind:type="resetPasswordData.showPassword ? 'text' : 'password'"
                                   class="form-control font-weight-bold"
                                   placeholder="Minimal 6 karakter"
                                   required
                                   minlength="6" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-secondary" v-on:click="resetPasswordData.showPassword = !resetPasswordData.showPassword">
                                    <i v-bind:class="resetPasswordData.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mb-3" v-if="resetPasswordData.mode === 'manual'">
                        <label class="font-weight-medium small mb-1 required">Konfirmasi Password Baru</label>
                        <input v-model="resetPasswordData.password_confirmation"
                               v-bind:type="resetPasswordData.showPassword ? 'text' : 'password'"
                               class="form-control form-control-sm"
                               placeholder="Ulangi password baru"
                               required
                               minlength="6" />
                    </div>


                    <div class="text-right pt-2 border-top">
                        <button type="button" class="btn btn-outline-secondary btn-sm px-4 mr-2" v-on:click="modal.resetPassword = false">
                            Batal
                        </button>
                        <button type="submit" class="btn btn-danger btn-sm px-4" v-bind:disabled="resetPasswordData.submitting">
                            <i class="fa fa-spinner fa-spin mr-1" v-if="resetPasswordData.submitting"></i>
                            <i class="fa fa-check mr-1" v-else></i>
                            Simpan Password
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>

        <!-- Modal Reset Success -->
        <b-modal v-model="modal.resetSuccess" modal-class="border-0" header-class="background-primary text-white" v-bind:centered="true" v-bind:hide-footer="true" size="md">
            <template slot="modal-header">
                <h5 class="modal-title font-weight-bold text-white mb-0">
                    <i class="fa fa-check-circle mr-2"></i> Password Berhasil Direset
                </h5>
                <button type="button" class="close text-white" v-on:click="modal.resetSuccess = false">&times;</button>
            </template>
            <div class="container text-center py-3">
                <div class="mb-3">
                    <span class="rounded-circle bg-success text-white d-inline-flex align-items-center justify-content-center" style="width: 55px; height: 55px;">
                        <i class="fa fa-check fa-2x"></i>
                    </span>
                </div>
                <h5 class="font-weight-bold text-dark mb-1">{{ student.user ? student.user.name : student.identity }}</h5>
                <p class="text-muted small mb-3">Username: <strong>{{ student.user ? student.user.username : student.identity }}</strong></p>

                <div class="card bg-light border-0 mb-3">
                    <div class="card-body p-3">
                        <small class="text-muted d-block text-uppercase font-weight-bold mb-1">Password Baru Siswa</small>
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="h4 font-weight-bold text-danger mb-0 mr-2" style="font-family: monospace; letter-spacing: 2px;">
                                {{ resetPasswordData.newPassword }}
                            </span>
                            <button type="button" class="btn btn-outline-danger btn-sm" v-on:click="copyPassword(resetPasswordData.newPassword)">
                                <i v-bind:class="resetPasswordData.copied ? 'fa fa-check' : 'fa fa-clone'" class="mr-1"></i>
                                {{ resetPasswordData.copied ? 'Tersalin!' : 'Salin' }}
                            </button>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-danger btn-sm px-5" v-on:click="modal.resetSuccess = false">
                    Tutup
                </button>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Multiselect from 'vue-multiselect';
    import Datepicker from 'vuejs-datepicker';
    import FileIcon from "@/components/item/FileIcon";
    import qs from 'qs';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { semesters } from '@/params.js';

    export default {
        name: "StudentView",
        components: {
            FileIcon,
            Multiselect,
            Datepicker
        },
        computed: mapState([
            'profile'
        ]),
        watch: {
            profile() {
                this.fetchBranches();
            },
            'form.student.branchID'(branchID) {
                if (branchID) {
                    this.axios.get(process.env.API_URL + '/branch-program', {params: {branchID: branchID}}).then(response => {
                        this.branchPrograms = response.data.data;

                        if (!(this.branchPrograms.find(branchProgram => branchProgram.id === this.branchProgramID))) {
                            this.branchProgramID = '';
                        }
                    });
                } else {
                    this.branchPrograms = [];
                    this.branchProgramID = '';
                }
            },
            branchProgramID(branchProgramID) {
                if (branchProgramID) {
                    this.axios.all([
                        this.axios.get(process.env.API_URL + '/pattern', {params: {branchProgramID: branchProgramID}}),
                        this.axios.get(process.env.API_URL + '/intensive-schedule', {params: {branchProgramID: branchProgramID}})
                    ]).then(this.axios.spread(function (responsePattern, responseIntensive) {
                        this.patterns = responsePattern.data.data;
                        this.intensives = responseIntensive.data.data;

                        if (!(this.patterns.find(pattern => pattern.id === this.form.verified.patternID))) {
                            this.form.verified.patternID = '';
                        }
                        if (!(this.intensives.find(intensive => intensive.id === this.form.verified.intensiveScheduleID))) {
                            this.form.verified.intensiveScheduleID = '';
                        }
                        if (!(this.intensiveClasses.find(intensiveClass => intensiveClass.id === this.form.verified.intensiveClassID))) {
                            this.form.verified.intensiveClassID = '';
                        }
                    }.bind(this)));
                } else {
                    this.patterns = [];
                    this.intensives = [];
                    this.form.verified.patternID = '';
                    this.form.verified.intensiveScheduleID = '';
                    this.form.verified.intensiveClassID = '';
                }
            },
            'form.verified.patternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.branchClasses = response.data.data;

                        if (!(this.branchClasses.find(branchClass => branchClass.id === this.form.verified.branchClassID))) {
                            this.form.verified.branchClassID = '';
                        }
                    });
                } else {
                    this.branchClasses = [];
                    this.form.verified.branchClassID = '';
                }
            },
            'form.verified.secondPatternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.secondBranchClasses = response.data.data;

                        if (!(this.secondBranchClasses.find(branchClass => branchClass.id === this.form.verified.secondBranchClassID))) {
                            this.form.verified.secondBranchClassID = '';
                        }
                    });
                } else {
                    this.secondBranchClasses = [];
                    this.form.verified.secondBranchClassID = '';
                }
            },
            'form.verified.thirdPatternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.thirdBranchClasses = response.data.data;

                        if (!(this.thirdBranchClasses.find(branchClass => branchClass.id === this.form.verified.thirdBranchClassID))) {
                            this.form.verified.thirdBranchClassID = '';
                        }
                    });
                } else {
                    this.thirdBranchClasses = [];
                    this.form.verified.thirdBranchClassID = '';
                }
            },
            'form.verified.fourthPatternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.fourthBranchClasses = response.data.data;

                        if (!(this.fourthBranchClasses.find(branchClass => branchClass.id === this.form.verified.fourthBranchClassID))) {
                            this.form.verified.fourthBranchClassID = '';
                        }
                    });
                } else {
                    this.fourthBranchClasses = [];
                    this.form.verified.fourthBranchClassID = '';
                }
            },
            'form.verified.intensiveScheduleID'(intensiveScheduleID) {
                if (intensiveScheduleID) {
                    this.axios.get(process.env.API_URL + '/intensive-class', {params: {intensiveScheduleID: intensiveScheduleID}}).then(response => {
                        this.intensiveClasses = response.data.data;

                        if (!(this.intensiveClasses.find(intensiveClass => intensiveClass.id === this.form.verified.intensiveClassID))) {
                            this.form.verified.intensiveClassID = '';
                        }
                    });
                } else {
                    this.intensiveClasses = [];
                    this.form.verified.intensiveClassID = '';
                }
						},
            selectedPenerimaanUniversity(university) {
                if (university) {
                    if (this.form.profile.Penerimaan_univ_1 && this.form.profile.Penerimaan_univ_1 !== university.name) {
                        this.selectedPenerimaanCourse = null;
                        this.form.profile.Penerimaan_prodi_1 = '';
                    }
                    this.form.profile.Penerimaan_univ_1 = university.name;
                    this.axios.get(process.env.API_URL + '/university-course', {
                        params: {
                            universityID: university.id,
                            pagination: 0
                        }
                    }).then(response => {
                        this.penerimaanUniversityCourses = response.data.data.data;
                        if (this.form.profile.Penerimaan_prodi_1) {
                            this.selectedPenerimaanCourse = this.penerimaanUniversityCourses.find(c => c.name === this.form.profile.Penerimaan_prodi_1) || null;
                        }
                    });
                } else {
                    this.form.profile.Penerimaan_univ_1 = '';
                    this.penerimaanUniversityCourses = [];
                    this.selectedPenerimaanCourse = null;
                    this.form.profile.Penerimaan_prodi_1 = '';
                }
            },
            selectedPenerimaanUniversity2(university) {
                if (university) {
                    if (this.form.profile.Penerimaan_univ_2 && this.form.profile.Penerimaan_univ_2 !== university.name) {
                        this.selectedPenerimaanCourse2 = null;
                        this.form.profile.Penerimaan_prodi_2 = '';
                    }
                    this.form.profile.Penerimaan_univ_2 = university.name;
                    this.axios.get(process.env.API_URL + '/university-course', {
                        params: {
                            universityID: university.id,
                            pagination: 0
                        }
                    }).then(response => {
                        this.penerimaanUniversityCourses2 = response.data.data.data;
                        if (this.form.profile.Penerimaan_prodi_2) {
                            this.selectedPenerimaanCourse2 = this.penerimaanUniversityCourses2.find(c => c.name === this.form.profile.Penerimaan_prodi_2) || null;
                        }
                    });
                } else {
                    this.form.profile.Penerimaan_univ_2 = '';
                    this.penerimaanUniversityCourses2 = [];
                    this.selectedPenerimaanCourse2 = null;
                    this.form.profile.Penerimaan_prodi_2 = '';
                }
            }
        },
        data() {
            return {
                form: {
                    student: {
                        username: '', name: '', identity: '', gradeID: '', btaGradeID: '', branchID: '', schoolID: '', email: '', image: ''
                    },
                    profile: {
                        nomor_formulir: '', tempat_lahir: '', tanggal_lahir: '', jenis_kelamin: 'Laki-laki', alamat_rumah: '', kode_pos: '', nomor_telp_rumah: '', nomor_hp_siswa: '',
                        nama_ayah: '', nomor_hp_ayah: '', pekerjaan_ayah: '', email_ayah: '', nama_ibu: '', nomor_hp_ibu: '', pekerjaan_ibu: '', email_ibu: '',
                        ukuran_jaket: '', diterima_jalur: '', diterima_univ: '', diterima_prodi: '',
                        SNMPTN_nomor: '', SNMPTN_univ_1: '', SNMPTN_prodi_1: '', SNMPTN_univ_2: '', SNMPTN_prodi_2: '', SNMPTN_univ_3: '', SNMPTN_prodi_3: '',
                        PPKB_nomor: '', PPKB_univ: '', PPKB_prodi: '',
                        TS_nomor: '', TS_univ: '', TS_prodi: '',
                        IUP_nomor: '', IUP_prodi: '',
                        SIMAK_nomor: '', SIMAK_prodi_1: '', SIMAK_prodi_2: '', SIMAK_prodi_3: '', SIMAK_prodi_4: '', SIMAK_prodi_5: '', SIMAK_prodi_6: '', SIMAK_prodi_7: '',
                        Mandiri_1_nomor: '', Mandiri_1_univ: '', Mandiri_1_prodi: '', Mandiri_2_nomor: '', Mandiri_2_univ: '', Mandiri_2_prodi: '', Mandiri_3_nomor: '', Mandiri_3_univ: '', Mandiri_3_prodi: '',
                        pembelajaran: '', sekolah_impian_1: '', sekolah_impian_2: '', sekolah_impian_3: '',
                        Penerimaan_univ_1: '', Penerimaan_prodi_1: '', Penerimaan_univ_2: '', Penerimaan_prodi_2: '', Penerimaan_univ_3: '', Penerimaan_prodi_3: ''
                    },
                    verified: {
                        patternID: '', branchClassID: '', secondPatternID: '', secondBranchClassID: '',thirdPatternID: '', thirdBranchClassID: '', fourthPatternID: '', fourthBranchClassID: '', payment: '', paymentNote: '', placement: '', intensiveScheduleID: '', intensiveClassID: ''
                    }
                },
                student: {additionals: {}, branch: {}, user: {}, term: {}},
                modal: {
                    remove: {
                        student: false,
                        file: false
                    },
                    resetPassword: false,
                    resetSuccess: false
                },
                resetPasswordData: {
                    mode: 'auto',
                    password: '',
                    password_confirmation: '',
                    send_email: true,
                    showPassword: true,
                    submitting: false,
                    copied: false,
                    newPassword: ''
                },
                school: null,
                branchProgramID: '',
                branches: [],
                patterns: [],
		terms: [],
                intensives: [],
                branchPrograms: [],
                grades: [],
                branchClasses: [],
                secondBranchClasses: [],
                thirdBranchClasses: [],
                fourthBranchClasses: [],
                intensiveClasses: [],
                schools: [],
								universities: [],
                penerimaanUniversityCourses: [],
                selectedPenerimaanUniversity: null,
                selectedPenerimaanCourse: null,
                penerimaanUniversityCourses2: [],
                selectedPenerimaanUniversity2: null,
                selectedPenerimaanCourse2: null,
                imagePreview: '',
                dateLanguage: id,
                semesters: semesters
            };
        },
        methods: {
            save(event) {
                var formData = new FormData();
                for (var group in this.form) {
                    for (var attribute in this.form[group]) {
                        var value = this.form[group][attribute];
                        if (value instanceof Date) {
                            formData.set(group + '[' + attribute + ']', this.$moment(value).format('YYYY-MM-DD'));
                        } else {
                            formData.set(group + '[' + attribute + ']', value);
                        }
                    }
                }
                this.axios.post(process.env.API_URL + '/student/update/' + this.student.userID, formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            removeStudent() {
                this.axios.post(process.env.API_URL + '/student/delete/' + this.student.userID).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'student/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.remove.student = false;
                });
            },
            removeFile() {
                if (this.student.psychoScore) {
                    this.axios.post(process.env.API_URL + '/psycho-score/delete-file/' + this.student.psychoScore.id).then(response => {
                        if (response.data.status) {
                            this.fetchStudent();
                            this.$toastr('success', response.data.message, 'Success');
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modal.remove.file = false;
                    });
                }
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.student.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            downloadFile() {
                if (this.student.psychoScore) {
                    let token = localStorage.getItem("vue-authenticate.vueauth_token");
                    window.location = process.env.API_URL + '/psycho-score/download-file/' + this.student.psychoScore.id + '?' + qs.stringify({token: token}, {encode: false});
                }
            },
	    downloadForm() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/form/' + this.student.userID + '?' + qs.stringify({token: token}, {encode: false});
            },
        downloadKuiform() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/kuiform/' + this.student.userID + '?' + qs.stringify({token: token}, {encode: false});
            },    
	    downloadKuibim() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/kuibim/' + this.student.userID + '?' + qs.stringify({token: token}, {encode: false});
            },
            downloadReport() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/report/' + this.student.userID + '?' + qs.stringify({token: token}, {encode: false});
            },
            openResetPasswordModal() {
                this.resetPasswordData.mode = 'default';
                this.setDefaultPassword();
                this.resetPasswordData.send_email = false;
                this.resetPasswordData.showPassword = true;
                this.resetPasswordData.copied = false;
                this.modal.resetPassword = true;
            },
            setDefaultPassword() {
                this.resetPasswordData.password = '12345678';
                this.resetPasswordData.password_confirmation = '12345678';
            },
            onResetModeChange() {
                if (this.resetPasswordData.mode === 'default') {
                    this.setDefaultPassword();
                } else {
                    this.resetPasswordData.password = '';
                    this.resetPasswordData.password_confirmation = '';
                }
            },
            submitResetPassword() {
                if (this.resetPasswordData.mode === 'manual' && this.resetPasswordData.password !== this.resetPasswordData.password_confirmation) {
                    this.$toastr('warning', 'Konfirmasi password tidak cocok', 'Peringatan');
                    return;
                }
                if (!this.resetPasswordData.password || this.resetPasswordData.password.length < 6) {
                    this.$toastr('warning', 'Password minimal 6 karakter', 'Peringatan');
                    return;
                }
                this.resetPasswordData.submitting = true;
                const studentId = this.student.userID || (this.student.user ? this.student.user.id : null) || this.$route.params.id;
                const payload = {
                    id: studentId,
                    userID: studentId,
                    studentID: studentId,
                    password: this.resetPasswordData.password,
                    password_confirmation: this.resetPasswordData.mode === 'manual' ? this.resetPasswordData.password_confirmation : this.resetPasswordData.password,
                    send_email: this.resetPasswordData.send_email
                };

                const extractError = (resOrErr) => {
                    if (!resOrErr) return 'Gagal mereset password';
                    const data = resOrErr.response ? resOrErr.response.data : (resOrErr.data || resOrErr);
                    if (data) {
                        if (data.errors && typeof data.errors === 'object' && Object.keys(data.errors).length) {
                            const first = data.errors[Object.keys(data.errors)[0]];
                            if (Array.isArray(first)) return first[0];
                            if (typeof first === 'string') return first;
                        }
                        if (data.message) return data.message;
                    }
                    if (resOrErr.message) return resOrErr.message;
                    return 'Gagal mereset password';
                };

                const handleSuccess = (response) => {
                    this.resetPasswordData.submitting = false;
                    this.modal.resetPassword = false;
                    this.resetPasswordData.newPassword = (response.data && response.data.data && response.data.data.password) ? response.data.data.password : this.resetPasswordData.password;
                    this.modal.resetSuccess = true;
                    this.$toastr('success', (response.data && response.data.message) ? response.data.message : 'Password berhasil direset', 'Berhasil');
                };

                // Gunakan endpoint resmi update student /student/update/{id} yang terbukti memperbarui password siswa di database
                const formData = new FormData();
                formData.set('password', this.resetPasswordData.password);
                formData.set('password_confirmation', this.resetPasswordData.mode === 'manual' ? this.resetPasswordData.password_confirmation : this.resetPasswordData.password);
                formData.set('send_email', '0');
                formData.set('student[name]', (this.student.user ? this.student.user.name : (this.form.student ? this.form.student.name : '')));
                formData.set('student[username]', (this.student.user ? this.student.user.username : (this.form.student ? this.form.student.username : '')));

                this.axios.post(process.env.API_URL + '/student/update/' + studentId, formData).then(response => {
                    if (response.data && response.data.status) {
                        handleSuccess(response);
                    } else {
                        this.resetPasswordData.submitting = false;
                        this.$toastr('warning', extractError(response), 'Peringatan');
                    }
                }).catch(err => {
                    this.resetPasswordData.submitting = false;
                    this.$toastr('warning', extractError(err), 'Peringatan');
                });
            },
            copyPassword(text) {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(text).then(() => {
                        this.resetPasswordData.copied = true;
                        this.$toastr('success', 'Password berhasil disalin ke clipboard', 'Tersalin');
                        setTimeout(() => { this.resetPasswordData.copied = false; }, 2500);
                    });
                } else {
                    const el = document.createElement('textarea');
                    el.value = text;
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                    this.resetPasswordData.copied = true;
                    this.$toastr('success', 'Password berhasil disalin ke clipboard', 'Tersalin');
                    setTimeout(() => { this.resetPasswordData.copied = false; }, 2500);
                }
            },
            fetchBranches() {
                if (!this.profile) return;
                if (this.profile.isAdmin) {
                    this.axios.get(process.env.API_URL + '/branch').then(response => {
                        this.branches = response.data.data;
                    });
                } else if (this.profile.isEmployee) {
                    if (this.profile.employee && this.profile.employee.isBranchStaff && this.profile.employee.branchStaff) {
                        this.form.student.branchID = this.profile.employee.branchStaff.branchID;
                    }
                }
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            downloadUTBK(index) {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/download-utbk?' + qs.stringify({index: index, studentID: this.student.userID, token: token}, {encode: false});
            },
            fileExtension(filename) {
                return filename.split('.').pop() || '';
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchStudent();
                    }
                } else {
                    this.fetchStudent();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            fetchStudent() {
                this.axios.get(process.env.API_URL + '/student/' + this.$route.params.id).then(response => {
                    this.student = response.data.data;

                    this.school = this.student.school;
                    this.imagePreview = this.student.imageUrl;

                    for (var key in this.student) {
                        if (typeof this.student[key] !== 'object') {
                            this.form.student[key] = this.student[key];
                        }
                    }
                    this.form.student = Object.assign(this.form.student, {
                        name: this.student.user ? this.student.user.name : '',
                        username: this.student.user ? this.student.user.username : '',
                        email: (this.student.user && this.student.user.email) ? this.student.user.email : '',
                        image: ''
                    });
                    this.form.profile = Object.assign({
                        Penerimaan_univ_1: '', Penerimaan_prodi_1: '', 
                        Penerimaan_univ_2: '', Penerimaan_prodi_2: '', 
                        Penerimaan_univ_3: '', Penerimaan_prodi_3: ''
                    }, this.student.additionals || {});

                    if (this.universities && this.universities.length && this.form.profile.Penerimaan_univ_1) {
                        this.selectedPenerimaanUniversity = this.universities.find(u => u.name === this.form.profile.Penerimaan_univ_1);
                    }
                    if (this.universities && this.universities.length && this.form.profile.Penerimaan_univ_2) {
                        this.selectedPenerimaanUniversity2 = this.universities.find(u => u.name === this.form.profile.Penerimaan_univ_2);
                    }

                    if (this.student.additionals && this.student.additionals.tanggal_lahir) {
                        var moment = this.$moment(this.student.additionals.tanggal_lahir, "YYYY-MM-DD");
                        if (moment.isValid()) {
                            this.form.profile.tanggal_lahir = moment.toDate();
                        }
                    }

                    if (this.student.studentVerified) {
                        if (this.student.studentVerified.pattern) {
                            this.branchProgramID = this.student.studentVerified.pattern.branchProgramID;
                        }
                        if (!this.branchProgramID && this.student.studentVerified.intensiveSchedule) {
                            this.branchProgramID = this.student.studentVerified.intensiveSchedule.branchProgramID;
                        }
                        for (var key in this.student.studentVerified) {
                            if (typeof this.student.studentVerified[key] !== 'object') {
                                this.form.verified[key] = this.student.studentVerified[key];
                            }
                        }
                    }

                    document.title = (this.student.user ? this.student.user.name : '') + ' - ' + process.env.APP_NAME;
                });
            },
            roleElligibleModified() {
                if (!this.profile) return false;
                return Boolean(this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee && this.profile.employee.isBranchStaff));
            },
            roleElligibleView() {
                if (!this.profile) return false;
                return Boolean(this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isBranchStaff || this.profile.employee.isBranchHead)));
            }
        },
        created() {
            this.fetchBranches();

            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade'),
		this.axios.get(process.env.API_URL + '/term'),
                this.axios.get(process.env.API_URL + '/school')
            ]).then(this.axios.spread(function (responseGrade, responseTerm, responseSchool) {
                this.grades = responseGrade.data.data;
		this.terms = responseTerm.data.data;
                this.schools = responseSchool.data.data;
            }.bind(this)));

						this.axios.get(process.env.API_URL + '/university').then(response => {
                this.universities = response.data.data;
                if (this.form.profile.Penerimaan_univ_1) {
                    this.selectedPenerimaanUniversity = this.universities.find(u => u.name === this.form.profile.Penerimaan_univ_1);
                }
                if (this.form.profile.Penerimaan_univ_2) {
                    this.selectedPenerimaanUniversity2 = this.universities.find(u => u.name === this.form.profile.Penerimaan_univ_2);
                }
            });

            this.fetchStudent();
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .btn.btn-outline-white { border-color: #fff; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }

    form[disabled] .user-avatar .overlay{ display: none; }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

		form[disabled] .multiselect-wrapper { display: none; }
    form:not([disabled]) .multiselect-readonly { display: none !important; }

    form[disabled] select.form-control-plaintext { -moz-appearance: none; -webkit-appearance: none; appearance: none; }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }
</style>

<style>
    /* Ukuran placeholder untuk Univ & Prodi, warna super pudar (#ccc) */
    .card-body .toggle-input::-webkit-input-placeholder { color: #ccc !important; font-size: 0.75em !important; }
    .card-body .toggle-input::-moz-placeholder { color: #ccc !important; font-size: 0.75em !important; }
    .card-body .toggle-input:-ms-input-placeholder { color: #ccc !important; font-size: 0.75em !important; }
    .card-body .toggle-input::placeholder { color: #ccc !important; font-size: 0.75em !important; }

    /* Tulisan abu-abu pudar di dropdown Univ/Prodi sebelum diklik */
    .card-body .toggle-multiselect .multiselect__placeholder { color: #ccc !important; font-size: 0.75em !important; display: inline-block; padding-top: 2px; }

    /* BENAR-BENAR HILANGKAN tulisan di search box saat diklik (Hanya bekerja di luar scoped / v-deep) */
    .card-body .toggle-multiselect .multiselect__input::-webkit-input-placeholder { color: transparent !important; }
    .card-body .toggle-multiselect .multiselect__input::-moz-placeholder { color: transparent !important; }
    .card-body .toggle-multiselect .multiselect__input:-ms-input-placeholder { color: transparent !important; }
    .card-body .toggle-multiselect .multiselect__input::placeholder { color: transparent !important; }

    /* Sembunyikan ketika mode disabled */
    form[disabled] .card-body .toggle-input::-webkit-input-placeholder { color: transparent !important; }
    form[disabled] .card-body .toggle-input::-moz-placeholder { color: transparent !important; }
    form[disabled] .card-body .toggle-input:-ms-input-placeholder { color: transparent !important; }
    form[disabled] .card-body .toggle-input::placeholder { color: transparent !important; }

    form[disabled] .card-body .toggle-multiselect .multiselect__placeholder { color: transparent !important; }
</style>



// WEBPACK FOOTER //
// src/components/student/View.vue